<template>
  <div class="wrapper">
    <div class="wrapper-parallax">
      <div class="parallax">
      </div>
      <h2>
        DESDE NUESTRA PLANTA ELABORADORA EN SAN PEDRO, BUENOS AIRES (ARGENTINA) OFRECEMOS LA MEJOR CALIDAD EN PRODUCTOS PARA MASCOTAS.
      </h2>

      <div class="bg-bird"> </div>
      <div class="content-bg-green">
        <div class="content-text">

          <div>
           Nuestros productos son naturales, sus componentes mantienen un alto estándar de calidad.
Durante el proceso de fabricación no utilizamos productos químicos, eliminando los riesgos que tienen dichos productos en la salud de las mascotas.
Pensamos en un mundo más verde, siguiendo políticas sustentables desarrollando productos orgánicos y biodegradables.
          </div>
        </div>
      </div>
      <div class="bio"> </div>

    </div>
    <div class="second-banner"></div>
  </div>
</template>
<script>
export default {
  name: "contact"
};
</script>
<style lang="scss" scoped>
$green: #7cb542;
.wrapper-parallax {
  position: relative;
}

.content-bg-green {
  height: 40%;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: $green;

  div.content-text {
    display: table;
    height: 100%;
    width: 50%;
    margin: auto;
    text-align: center;
    > div {
      display: table-cell;
      vertical-align: middle;
      color: white;

      font-family: "Montserrat";
    }
  }
}

.bio {
  background: url("~@/assets/images/desktop/bio.png") no-repeat center center;
  width: 100%;
  height: 200px;
  position: absolute;
  top: 45%;
}

.bg-bird {
  background: url("~@/assets/images/desktop/pajarito.png") no-repeat;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  background-position: -300px;
  z-index: 3;
}

.parallax {
  background-image: url("~@/assets/images/desktop/back_paralax.jpg");
  height: 740px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

h2 {
  position: absolute;
  top: 25%;
  width: 100%;
  text-align: center;
  padding: 0 20rem;
  color: white;
  font-weight: 400;
  font-family: "Montserrat";
  padding: 0px 32%;
  font-weight: bold;
}

.text {
  position: absolute;
  bottom: -25px;
}

.second-banner {
  background: url("~@/assets/images/desktop/prefooter_animales.jpg") no-repeat
    center center white;
  background-size: cover;
  width: 100%;
  height: 510px;
}

@media only screen and (max-width: 48.0625em) {
  .second-banner {
    background: url("~@/assets/images/mobile/prefooter_animales_mobile.jpg")
      no-repeat center center white;
    background-size: cover;
    width: 100%;
    height: 220px;
  }

  .parallax {
    background-image: url("~@/assets/images/mobile/back_paralax_mobile.jpg");
    height: 660px;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .bio {
    background: url("~@/assets/images/desktop/bio.png") no-repeat center center;
    width: 100%;
    height: 200px;
    position: absolute;
    top: 40%;
  }

  .bg-bird {
    display: none;
  }
  h2 {
    padding: 0;
  }

  .content-bg-green {
    div.content-text {
      padding: 2em 1em 2em;
      width: 100%;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/parallax.vue